import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';


import Print from 'vue-print-nb'
Vue.use(Print);

//引入地址联动的插件
import VueAreaLinkage from "vue-area-linkage";
import "vue-area-linkage/dist/index.css";



import axios from "axios";
Vue.prototype.$axios = axios;
import '@/static/css/common.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'

Vue.prototype.$video = Video

Vue.use(VueAreaLinkage);
Vue.use(ElementUI);
Vue.use(MuseUI);
Vue.use(ViewUI);


//路由拦截
// router.beforeEach((to, from, next) => {
// 	// 添加动态(菜单)路由
// 	// 1. 已经添加 or 全局路由, 直接访问
// 	// 2. 获取菜单列表, 添加并保存本地存储
// 	if (localStorage.getItem('token')) {
// 	  next()
// 	} else {
// 		router.push({ name: 'login' })
// 	}
//   })



/*************axios拦截器*************************************/
// 请求拦截器
axios.interceptors.request.use(
	config=>{
		// console.log(33,config);
		// config.url = "http://127.0.0.1"+config.url;
		// config.url = "/ele"+config.url;
		config.headers={
			"Authorization":localStorage.token
		}
		return config;
	},
	err => {
        return Promise.reject(err);
    }
)
// 响应拦截器
// axios.interceptors.response.use(({data})=>{
// 	if(data.ok === -2){
// 		store.commit("OUT_LOGIN");
// 	}
// 	return data;
// });
  




//阻止启动生产消息,控制台少一行消息
Vue.config.productionTip = false

new Vue({
	router,
	render: function (h) { return h(App) }
  }).$mount('#app');
  